import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import LandingPage from "./Pages/LandingPage";
import Mint from "./Pages/Mint";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="mint" element={<Mint />} />
      </Routes>
    </>
  );
}
